// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppEvent } from '@interfaces/interfaces';
import { ApiService } from '@services/api.service';
import { SettingsService } from '@services/settings.service';

@Component({
    selector: 'app-token-validation',
    templateUrl: './token-validation.component.html',
    styleUrls: ['./token-validation.component.scss'],
})
export class TokenValidationComponent implements OnInit {
    @Output() signal: EventEmitter<AppEvent> = new EventEmitter();
    @Input() token?: string;

    constructor(
        private readonly apiService: ApiService,
        private readonly settingsService: SettingsService
    ) {}

    cancel() {
        this.signal.emit({ context: 'cancel', data: null });
    }

    ngOnInit(): void {
        if (!this.token) {
            return;
        }

        this.apiService
            .getV2$<{ valid: boolean; expired: boolean; oemDealerId: string; oemCode: string }>(`api/auth/enrollment/validate?token=${this.token}`, null, false)
            .subscribe((resp) => {
                const response = resp.data;
                if (!response.valid) {
                    this.signal.emit({ context: 'fail', data: 'invalid' });
                } else if (response.expired) {
                    this.signal.emit({ context: 'fail', data: 'expired' });
                    this.signal.emit({
                        context: 'data',
                        data: { oemDealerId: response.oemDealerId },
                    });
                } else {
                    this.settingsService.setOemCode(response.oemCode);
                    this.signal.emit({ context: 'data', data: { oemCode: response.oemCode } });
                    this.signal.emit({ context: 'next', data: null });
                }
            });
    }
}
